export default class Sort {
  constructor({
    direction = 'DESC',
    property = 'last15Average',
  } = {}) {
    this.direction = direction;
    this.property = property;
  }
}
